import 'bulma/css/bulma.min.css';
import '@easylife365/react/index.css';

import '@fortawesome/fontawesome-svg-core/styles.css';

import ReactDOM from 'react-dom/client';
import App from './App';
import { AppLayout, AppProvider } from '@easylife365/react';
import { productConfig } from './constants';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <AppProvider config={productConfig}>
    <AppLayout logo={productConfig.app.headerLogo}>
      <App />
    </AppLayout>
  </AppProvider>
);
